import { IHSCode, IHSCodeData } from './hs-code.types';

import { AbstractModel } from '@/models/base';

/**
 * A class representing model HSCode.
 */
export class HSCode extends AbstractModel implements IHSCode {
  readonly code: string;
  readonly description: string = '';

  constructor(data: IHSCodeData) {
    super();

    this.validate(data, ['code']);

    this.code = data.code!;
    if (data.description) {
      this.description = data.description;
    }
  }

  toString(): string {
    return this.code;
  }
}
